/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlipHorizontal = createReactComponent("outline", "flip-horizontal", "IconFlipHorizontal", [["path", { "d": "M3 12l18 0", "key": "svg-0" }], ["path", { "d": "M7 16l10 0l-10 5l0 -5", "key": "svg-1" }], ["path", { "d": "M7 8l10 0l-10 -5l0 5", "key": "svg-2" }]]);

export { IconFlipHorizontal as default };
//# sourceMappingURL=IconFlipHorizontal.mjs.map
